import { z } from "zod";

import { NO_DISPLAY, YES_DISPLAY } from "@/intake-forms/constants/yes-no-display";
import { zSignatureInitialsRequired } from "@/utils/zod";

const numericOrEmptyField = z.union([z.string(), z.number()]).optional();
const yesNoDisplayField = z.enum([YES_DISPLAY, NO_DISPLAY]).nullable().optional();

export const fetalHeartRateFlowsheetFormSchema = z.object({
  fhrDate: z.date().nullable(),
  fhrTime: z.string().nullable(),
  fhrBPMLow: numericOrEmptyField,
  fhrBPMHigh: numericOrEmptyField,
  fhrDurationOfListening: numericOrEmptyField,
  fhrListeningDevice: z.string().nullable().optional(),
  fhrRelationToContractions: z.array(z.string()).optional(),
  accelerationsDetected: yesNoDisplayField,
  decelerationsDetected: yesNoDisplayField,
  assessBaseline: yesNoDisplayField,
  fhrBaseline: numericOrEmptyField,
  fhrDurationOfListeningBaseline: numericOrEmptyField,
  fhrNotes: z.string().optional(),
  fhrSignatureInitials: zSignatureInitialsRequired(),
});

export type FetalHeartRateFlowsheetFormSchemaType = z.infer<
  typeof fetalHeartRateFlowsheetFormSchema
>;
